"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const _1 = require(".");
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
class InvoiceData extends BaseModel_1.default {
    defaults() {
        return {
            entries: new _1.Collection(),
            summary: {},
        };
    }
}
exports.default = InvoiceData;
//# sourceMappingURL=InvoiceData.js.map